<div class="text" [matTooltip]="text" [matTooltipDisabled]="ele.scrollWidth<=ele.offsetWidth" #ele>
    {{text}}</div>